import { c as _c } from "react/compiler-runtime";
import animationStyles from '@/components/Atoms/Animation/Animation.module.css';
import classNames from '@/utils/classNames';
import type { FCC } from 'react-fc';
import styles from './CommaList.module.css';
export const CommaList: FCC<{
  animate?: boolean;
}> = t0 => {
  const $ = _c(6);
  const {
    children,
    className,
    animate
  } = t0;
  let t1;
  if ($[0] !== animate || $[1] !== className) {
    t1 = classNames(styles.list, {
      [animationStyles.fadeChildren]: animate
    }, className);
    $[0] = animate;
    $[1] = className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <ul className={t1}>{children}</ul>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};